export default __webpack_public_path__ + "media/images/chilly-681e6e0d9456c296e33b077ae4b07683.png";